import { guardString } from "@msuite/utils/strings";
import { BlankSlate } from "../blank-slate";
import { icon } from "../icons";
import { useTranslation } from "../localization";
import { useVideoRecorder } from "./use-video-recorder";

export function VideoRecorderPlayer() {
	/** Store */
	const controller = useVideoRecorder();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="w-full aspect-video card p-0 max-h-[60vh] flex-center overflow-hidden border-none">
			<div className="h-full aspect-video">
				{controller.hasVideo ? (
					<video
						src={guardString(controller.videoUrl)}
						className="w-full aspect-video bg-black"
						controls
					/>
				) : controller.isAssembling ? (
					// Between Stop and the finished blob there is nothing to show and nothing to
					// start. Offering the capture prompt here would read as "your recording is
					// gone" at the one moment the author is waiting for it.
					<BlankSlate
						Icon={icon("Loader")}
						label={t("video_recorder.assembling_recording")}
					/>
				) : controller.isRecording ? (
					// While a recording runs this area must not be a button. It used to carry
					// `onToggleRecording`, so the full-size surface labelled "click here to
					// capture a video" was in fact a Stop button — and since the menu below now
					// offers Stop and Pause explicitly, a third, mislabelled one is worse still.
					<BlankSlate
						Icon={icon("Circle")}
						label={t(controller.isPaused ? "video_recorder.paused" : "video_recorder.recording")}
					/>
				) : (
					<BlankSlate
						Icon={icon("Camera")}
						label={t("video_recorder.click_to_capture_video")}
						onClick={controller.onToggleRecording}
					/>
				)}
			</div>
		</div>
	);
}
